import Vue from "vue";
import moment from "moment";
// import  from "date-fns/format";

// Vue.filter("formatTime", (value) => {
//   return format(new Date(value), "MMM do, uuuu, h:m a");
// });

Vue.filter("timeFilter", (value) => {
  return moment(value).utc().format("LT");
});
Vue.filter("dateFilter", (value) => {
  return moment(value).format("Do MMMM YYYY");
});
Vue.filter("neatDate", (value) => {
  return moment(value).format("Do MMMM YYYY, h:mm:ss a");
});
Vue.filter("fromNow", (value) => {
  return moment(value).fromNow();
});
Vue.filter("removeDash", (value) => {
  return value.replace("_", " ");
});
